import { FC } from 'react';

import { QuoteStatus } from '__generated__/GQL';
import CardDetailsHeader from 'features/Work/components/CardDetailsHeader';
import { CardDetailsHeaderOptions } from 'features/Work/components/CardDetailsHeader/types';
import { useQuoteModals } from 'features/Work/pages/Quotes/hooks/useQuoteModals';

import { Quote } from '../../../../../../hooks/queries/useGetQuote';
import locales from './locales';

interface DetailHeaderProps {
  quote: Quote;
}

const DetailHeader: FC<DetailHeaderProps> = ({ quote }) => {
  const { openModal } = useQuoteModals();

  const canEditStatus = quote.status === QuoteStatus.Sent;

  const menuOptions: CardDetailsHeaderOptions[] = [
    {
      description: locales.quoteAcceptedDescription,
      icon: 'tick',
      label: locales.quoteAcceptedTitle,
      onClick: () =>
        openModal({
          name: 'mark-as-accepted',
          props: { ...quote, isFromList: false },
        }),
    },
    {
      description: locales.quoteArchivedDescription,
      icon: 'cross',
      label: locales.quoteArchivedTitle,
      onClick: () => openModal({ name: 'archive', props: quote }),
    },
    {
      description: locales.quoteRevisedDescription,
      icon: 'edit',
      label: locales.quoteRevisedTitle,
      onClick: () => openModal({ name: 'revise', props: quote }),
    },
  ];

  return (
    <CardDetailsHeader
      canEditStatus={canEditStatus}
      item={quote}
      options={menuOptions}
    />
  );
};

export default DetailHeader;
